import script from "./detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true"

import "./detail.vue?vue&type=style&index=0&id=13a2f378&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13a2f378"]])

export default __exports__